/* ============
 * Vuex Store
 * ============
 *
 * The store of the application.
 *
 * http://vuex.vuejs.org/en/index.html
 */

import Vue from 'vue';
import Vuex from 'vuex';
import createLogger from 'vuex/dist/logger';

// Modules
import account from './modules/account';
import auth from './modules/auth';
import general from './modules/general';
import product from './modules/product';
import order from './modules/order';
import wordboard from './modules/wordboard';
import customer from './modules/customer';
import group from './modules/group';

Vue.use(Vuex);

const debug = process.env.NODE_ENV !== 'production';
const redactToken = token => (token ? '[REDACTED]' : '');
const sanitizeStateForLogging = state => ({
  ...state,
  auth: state.auth ? {
    ...state.auth,
    token: redactToken(state.auth.token),
  } : state.auth,
});
const sanitizeMutationForLogging = mutation => (
  mutation.type === 'auth/LOGIN'
    ? {
      ...mutation,
      payload: redactToken(mutation.payload),
    }
    : mutation
);

export default new Vuex.Store({
  /**
   * Assign the modules to the store
   */
  modules: {
    account,
    auth,
    general,
    product,
    order,
    wordboard,
    customer,
    group,
  },

  /**
   * If strict mode should be enabled
   */
  strict: debug,

  /**
   * Plugins used in the store
   */
  plugins: debug ? [createLogger({
    transformer: sanitizeStateForLogging,
    mutationTransformer: sanitizeMutationForLogging,
  })] : [],
});



// WEBPACK FOOTER //
// ./src/store/index.js